<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, defineProps, defineExpose } from 'vue';

/*==================================================================*/
/*================== IMPORTS DOS COMPONENTES =======================*/
/*==================================================================*/

import ModalConfirmacao from '@/components/v2/modais/ModalConfirmacao/ModalConfirmacao.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    job: {
        type: Object,
        default: () => ({})
    },
    confirmar: {
        type: Function,
        required: true
    }
});

/*==================================================================*/
/*================== MODAL REF =====================================*/
/*==================================================================*/

const modalConfirmacaoRef = ref(null);

/*==================================================================*/
/*================== ABRIR / FECHAR MODAL ===========================*/
/*==================================================================*/

const abrirModal = async () => {

    await modalConfirmacaoRef.value?.abrirModal();

};

const fecharModal = async () => {

    await modalConfirmacaoRef.value?.fecharModal();

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalConfirmacao
        ref="modalConfirmacaoRef"
        max-width="600"
        :disabled="props.disabled"
        :confirmar="props.confirmar"
    >

        <template #header>
            Finalizar Job
        </template>

        <template #body>
            Deseja realmente finalizar o Job "{{ props.job?.codigo }}"?
        </template>

    </ModalConfirmacao>

</template>
